module.exports = __webpack_public_path__ + "img/红心中级大师@2x.97f21b6a.png";